(() => {
  if (window.__upProductPurchaseLoaded) return;
  window.__upProductPurchaseLoaded = true;

  const applyColorBoxes = (root = document) => {
    root.querySelectorAll?.(".up-product-purchase .block-swatch:has(.block-swatch__color)").forEach((box) => {
      const tile = box.querySelector(".block-swatch__color");
      const style = getComputedStyle(tile);
      const background = style.backgroundImage !== "none" ? style.backgroundImage : style.backgroundColor;
      const rgb = background.match(/rgba?\(\s*(\d+(?:\.\d+)?)\D+(\d+(?:\.\d+)?)\D+(\d+(?:\.\d+)?)/i);

      box.style.setProperty("--up-swatch-background", background);

      if (rgb) {
        const channels = rgb.slice(1, 4).map((value) => {
          const channel = Number(value) / 255;
          return channel <= 0.04045 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4;
        });
        const luminance = 0.2126 * channels[0] + 0.7152 * channels[1] + 0.0722 * channels[2];
        const useDarkText = luminance > 0.42;
        box.style.setProperty("--up-swatch-text", useDarkText ? "#111111" : "#ffffff");
        box.style.setProperty("--up-swatch-shadow", useDarkText ? "none" : "0 1px 1px rgb(0 0 0 / 28%)");
      }
    });
  };

  applyColorBoxes();
  document.addEventListener("product:rerender", () => requestAnimationFrame(() => applyColorBoxes()), true);

  document.addEventListener("change", async (event) => {
    const select = event.target.closest?.(".up-sticky-cart__variant-select");
    if (!select) return;

    const quickAdd = select.closest("product-quick-add");
    const form = document.getElementById(quickAdd?.getAttribute("form"));
    if (!(form instanceof HTMLFormElement)) return;

    select.disabled = true;
    quickAdd?.setAttribute("aria-busy", "true");

    try {
      const url = new URL(select.dataset.productUrl, window.location.origin);
      url.searchParams.set("variant", select.value);
      url.searchParams.set("section_id", select.dataset.sectionId);

      const response = await fetch(url);
      if (!response.ok) throw new Error("Could not change variant.");

      const htmlFragment = document.createRange().createContextualFragment(await response.text());
      form.elements.id.value = select.value;
      form.elements.id.dispatchEvent(new Event("change", { bubbles: true }));
      form.dispatchEvent(new CustomEvent("product:rerender", {
        detail: { htmlFragment, productChange: false }
      }));

      const pageUrl = new URL(window.location.href);
      pageUrl.searchParams.set("variant", select.value);
      window.history.replaceState({ path: pageUrl.toString() }, "", pageUrl.toString());
    } catch (error) {
      select.disabled = false;
      quickAdd?.removeAttribute("aria-busy");
      console.error(error);
    }
  });

  document.addEventListener("change", (event) => {
    const select = event.target.closest?.(".up-addon__variant-select");
    if (!select) return;

    const addon = select.closest(".up-addon");
    const checkbox = addon?.querySelector("[data-up-addon-id]");
    const price = addon?.querySelector(".up-addon__price");
    const option = select.selectedOptions[0];

    if (checkbox) checkbox.value = select.value;
    if (price && option?.dataset.price) price.textContent = option.dataset.price;
  });

  document.addEventListener("submit", async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.getAttribute("is") !== "product-form") return;
    if (!form.closest(".up-product-purchase")) return;

    const selectedAddons = [...form.elements].filter(
      (element) => element.matches?.("[data-up-addon-id]:checked")
    );
    if (selectedAddons.length === 0) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const buttons = [...form.elements].filter((element) => element.type === "submit");
    buttons.forEach((button) => button.setAttribute("aria-busy", "true"));

    const sections = ["variant-added"];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections } })
    );

    const quantity = Number(form.elements.quantity?.value || 1);
    const items = [
      { id: Number(form.elements.id.value), quantity },
      ...selectedAddons.map((input) => ({ id: Number(input.value), quantity: 1 }))
    ];

    try {
      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: JSON.stringify({
          items,
          sections,
          sections_url: `${Shopify.routes.root}variants/${form.elements.id.value}`
        })
      });
      const payload = await response.json();

      if (!response.ok) throw new Error(payload.description || "Could not add products to cart.");

      if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
        window.location.href = `${Shopify.routes.root}cart`;
        return;
      }

      const cart = await fetch(`${Shopify.routes.root}cart.js`).then((cartResponse) => cartResponse.json());
      cart.sections = payload.sections;
      form.dispatchEvent(new CustomEvent("variant:add", { bubbles: true, detail: { items: payload.items, cart } }));
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:change", { bubbles: true, detail: { baseEvent: "variant:add", cart } })
      );
    } catch (error) {
      form.dispatchEvent(new CustomEvent("cart:error", { bubbles: true, detail: { error: error.message } }));
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    } finally {
      buttons.forEach((button) => button.removeAttribute("aria-busy"));
    }
  }, true);
})();
